import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-collections-items',
  templateUrl: './collections-items.component.html',
  styleUrls: ['./collections-items.component.scss']
})
export class CollectionsItemsComponent implements OnInit {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }
  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
